import { getCancelSubscriptionLink } from "../services/apiV2";
import { useEffect, useRef, useState } from "react";

type TUseGetCancelSubscriptionLinkParams = {
  onSuccess?: (link: string) => void;
};

export const useGetCancelSubscriptionLink = (
  params?: TUseGetCancelSubscriptionLinkParams,
) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const abortControllerRef = useRef<AbortController | null>(null);

  const getLink = async () => {
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setLoading(true);
    setError(null);
    try {
      const res = await getCancelSubscriptionLink({
        config: { signal: controller.signal },
      });
      if (res.status === 200) {
        params?.onSuccess?.(res.data.link);
      }
    } catch (e) {
      setError("Failed to get cancel subscription link. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return { getLink, loading, error };
};
